import type { SortDir, Status } from '../../stores/common/pagination-query-params';

export interface ListParams {
  filtro: string;
  status: Status;
  columna: string;
  pagina: number;
  limite: number;
  dir: SortDir;
  orden: string;
}

type ToString<Type> = {
  [Property in keyof Type]: string;
};

type StringListParams = ToString<ListParams>;

export const listParamsToString = (p: ListParams): StringListParams => ({
  filtro: p.filtro,
  status: p.status as string,
  columna: p.columna,
  pagina: p.pagina.toString(),
  limite: p.limite.toString(),
  dir: p.dir as string,
  orden: p.orden
});

export const fromSearchParams = (
  p: URLSearchParams,
  nombreColumnaFiltro: string = 'nombre'
): ListParams => {
  const filtro = p.get('filtro') ?? '';
  const status = (p.get('status') ?? 'activos') as Status;
  const columna = p.get('columna') ?? nombreColumnaFiltro;
  const pagina = p.get('pagina') ?? '0';
  const limite = p.get('limite') ?? '10';
  const dir = (p.get('dir') ?? 'asc') as SortDir;
  const orden = p.get('orden') ?? 'codigo';

  return {
    filtro,
    status,
    columna,
    pagina: Number.parseInt(pagina, 10),
    limite: Number.parseInt(limite, 10),
    dir,
    orden
  };
};
